module.exports = __webpack_public_path__ + "img/eps.4f7efdf.svg";